import { ActionSubTypes } from '../../ActionSubTypes';
import { IAction, IPropAction } from '../../../models/ActionModels';
import { IError } from '../../../models/StateModels';
import ActionFunctions from '../../core/ActionFunctions';

export const action_page_loaded = (): IAction => {
  return ActionFunctions.action_page_loaded(ActionSubTypes.PAGE_DASHBOARD);
};

export const action_page_unloaded = (): IAction => {
  return ActionFunctions.action_page_unloaded(ActionSubTypes.PAGE_DASHBOARD);
};

export const action_page_props_sent = <T>(
  data: T,
  error?: IError | null | undefined
): IPropAction<T> => {
  return ActionFunctions.action_page_props_sent<T>(
    ActionSubTypes.PAGE_DASHBOARD,
    data,
    error
  );
};
